export default __webpack_public_path__ + "static/media/highRiseFormingRodman.107ab43b.jpg";